// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.waves-effect {
  position: relative;
  overflow: hidden;
}
.waves-effect .waves-ripple {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  animation: ripple-effect 0.7s ease;
}

@keyframes ripple-effect {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  100% {
    width: 200%;
    padding-bottom: 200%;
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/@core/components/ripple-button/ripple-button.scss"],"names":[],"mappings":"AAMA;EACE,kBAAA;EACA,gBAAA;AALF;AAME;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,oCAAA;EACA,kCAAA;AAJJ;;AAQA;EACE;IACE,UAAA;EALF;EAOA;IACE,UAAA;EALF;EAOA;IACE,WAAA;IACA,oBAAA;IACA,UAAA;EALF;AACF","sourcesContent":["// Component: Ripple Button\r\n// ========================================================================\r\n\r\n@import '../../scss/base/bootstrap-extended/include';\r\n@import '../../scss/base/components/include';\r\n\r\n.waves-effect {\r\n  position: relative;\r\n  overflow: hidden;\r\n  .waves-ripple {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    opacity: 0;\r\n    width: 0;\r\n    height: 0;\r\n    border-radius: 50%;\r\n    background: rgba($color: $white, $alpha: 0.2);\r\n    animation: ripple-effect 0.7s ease;\r\n  }\r\n}\r\n\r\n@keyframes ripple-effect {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  25% {\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    width: 200%;\r\n    padding-bottom: 200%;\r\n    opacity: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
